import cn from 'classnames';
import styles from './styles.module.css';

export const PageTemplate = (props: IPageTemplateProps) => {
  const { className, mainClassName, children, header, ...rest } = props;
  const rootClass = cn(className, styles.root);
  const mainClass = cn(mainClassName, styles.main);

  return (
    <div className={rootClass} {...rest}>
      {header && (
        <header className={styles.header}>
          <h1 className={styles.title}>{header}</h1>
        </header>
      )}

      <main className={mainClass}>{children}</main>
    </div>
  );
};

export interface IPageTemplateProps
  extends React.HTMLAttributes<HTMLDivElement>,
    React.PropsWithChildren {
  header?: string;
  mainClassName?: string;
}
